import { Plugin } from '@tiptap/pm/state'
import Link from '@tiptap/extension-link'

const parseDataVueHref = (raw) => {
  if (!raw) return null
  try { return JSON.parse(raw) } catch (e) { return null }
}

const addhttp = (url) => {
  if (!/^(?:f|ht)tps?:\/\//.test(url)) {
    url = 'https://' + url
  }
  return url
}

const getUrl = (href) => {
  if (href.indexOf('.') !== -1) {
    return addhttp(href)
  }

  return href
}

const CustomLink = Link.extend({
  addOptions () {
    return {
      ...this.parent?.(),
      levels: ['id', 'href', 'target']
    }
  },

  addAttributes () {
    const parent = this.parent?.() || {}

    return {
      ...parent,
      file: {
        default: null
      },
      download: {
        default: null
      },
      dataVueHref: {
        default: null
      },
      styleeffect: {
        default: null
      },
      fromGlobalStyle: {
        default: null
      },
      id: {
        default: null
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'a[href]',
        getAttrs: dom => {
          const raw = dom.getAttribute('datavuehref') || dom.getAttribute('data-vue-href') || dom.getAttribute('dataVueHref')
          const dvh = parseDataVueHref(raw)
          const hrefFromData = dvh && dvh.href && dvh.href.href ? dvh.href.href : null
          const idFromData = dvh && dvh.href && dvh.href.id ? dvh.href.id : null

          const domHref = dom.getAttribute('href')
          const finalHref = hrefFromData || getUrl(domHref || '')

          const domDownload = dom.hasAttribute('download') ? (dom.getAttribute('download') || '') : null
          const inferredDownload = domDownload !== null ? domDownload : (idFromData === 'download-file' ? '' : null)

          return {
            href: finalHref,
            file: null,
            dataVueHref: raw,
            target: dom.getAttribute('target') || '_self',
            download: inferredDownload,
            styleeffect: dom.getAttribute('styleeffect'),
            fromGlobalStyle: dom.getAttribute('fromGlobalStyle'),
            id: dom.getAttribute('id')
          }
        }
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    const raw = HTMLAttributes.dataVueHref
    const dvh = parseDataVueHref(raw)
    const hrefFromData = dvh && dvh.href && dvh.href.href ? dvh.href.href : null
    const idFromData = dvh && dvh.href && dvh.href.id ? dvh.href.id : HTMLAttributes.id

    const finalHref = hrefFromData || HTMLAttributes.href

    const attrs = {
      ...HTMLAttributes,
      id: HTMLAttributes.id,
      dataVueHref: raw,
      styleeffect: HTMLAttributes.styleeffect,
      fromGlobalStyle: HTMLAttributes.fromGlobalStyle,
      href: getUrl(finalHref || ''),
      target: HTMLAttributes.target || '_self'
    }

    const downloadVal = typeof HTMLAttributes.download !== 'undefined' && HTMLAttributes.download !== null
      ? HTMLAttributes.download
      : (idFromData === 'download-file' ? '' : null)

    if (downloadVal !== null) {
      attrs.download = downloadVal
    } else {
      delete attrs.download
    }

    return ['a', attrs, 0]
  },

  addProseMirrorPlugins () {
    if (!this.options.openOnClick) {
      return []
    }

    return [
      new Plugin({
        props: {
          handleClick: () => {
            return false
          }
        }
      })
    ]
  }
})

export default CustomLink
